import api from './api';

class CartService {
    async getCart() {
        return api.get('cart/');
    }

    async addToCart(item) {
        // item: { product_variant_id, quantity }
        return api.post('cart/add_item/', item);
    }

    async updateItem(itemId, quantity) {
        return api.patch(`cart/${itemId}/update-item/`, { quantity });
    }

    async removeItem(itemId) {
        return api.delete(`cart/${itemId}/remove-item/`);
    }

    async clearCart() {
        return api.post('cart/clear/');
    }
}

export default new CartService();
